<template>
    <div class="modal-card" style="width: auto">
        <section class="modal-card-body">
<!--
            <pre style="padding-left: 70px">{{basic}}{{filterReturned}}</pre>
-->
            <div class="container is-max-tablet is-max-desktop is-max-fullhd">
                <div class="columns mt-5">
                    <div class="column is-12-tablet is-9-desktop">

                        <div id="filters" class="p-t-70">
                            <div class="is-flex is-align-items-center m-b-30 is-hidden-mobile">
                                <h2 class="title-filter has-text-weight-bold is-size-4-tablet is-size-5">Advanced Filters</h2>
                            </div>
                            <div class="is-flex is-justify-content-center m-b-30 is-hidden-tablet">
                                <div class="is-flex is-size-6">
                                    <button class="filters-link is-hidden-tablet" @click="switchIt()">Basic Filters</button>
                                    <button class="filters-selected is-hidden-tablet has-text-light" disabled>Advanced Filters</button>
                                </div>
                            </div>

                                <h3 class="is-uppercase has-text-weight-bold mb-5 is-hidden-mobile"><img src="/img/benchmark.png" > Spread vs User Benchmark
                                    <a class="clear-btn" @click="clearSpreadBenchmark">Clear</a>
                                </h3>
                                <h3 class="is-uppercase has-text-weight-bold mb-5 is-hidden-tablet"><img src="/img/benchmark.png" > SPRD V USER BMARK
                                    <a class="clear-btn" @click="clearSpreadBenchmark">Clear</a>
                                </h3>
                                <template v-if="this.$store.state.search.compareBenchmarkFilter">
                                    <div class="columns is-justify-content-center">
                                        <div class="column is-9-tablet">
                                            <div class="filter-form-control mb-6">
                                                <quantile
                                                    v-on:slider-change="basic.minMaxBenchmarkytd=$event"
                                                    :title="'Year to Date'"
                                                    :suffix="'%'"
                                                    :minLimit=parseFloat(this.minSpreadBenchmarkYTD)
                                                    :maxLimit=parseFloat(this.maxSpreadBenchmarkYTD)
                                                    :smalltitle="false"
                                                    :arr="basic.minMaxBenchmarkytd"
                                                    :step="1"
                                                    :fixed="0"
                                                    :format="'percent'"
                                                    :nobuttons="true"
                                                    :clear="clearSpreadBenchmarkSlider">
                                                </quantile>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="columns is-justify-content-center">
                                        <div class="column is-9-tablet">

                                            <div class="filter-form-control mb-6">
                                                <quantile
                                                    v-on:slider-change="basic.minMaxBenchmark1y=$event"
                                                    :title="'1 Year'"
                                                    :suffix="'%'"
                                                    :minLimit=parseFloat(this.minSpreadBenchmark1Y)
                                                    :maxLimit=parseFloat(this.maxSpreadBenchmark1Y)
                                                    :smalltitle="false"
                                                    :step="1"
                                                    :fixed="0"
                                                    :format="'percent'"
                                                    :arr="basic.minMaxBenchmark1y"
                                                    :nobuttons="true"
                                                    :clear="clearSpreadBenchmarkSlider">
                                                </quantile>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="columns is-justify-content-center">
                                        <div class="column is-9-tablet">

                                            <div class="filter-form-control mb-6">
                                                <quantile
                                                    v-on:slider-change="basic.minMaxBenchmark3y=$event"
                                                    :title="'3 Year'"
                                                    :suffix="'%'"
                                                    :minLimit=parseFloat(this.minSpreadBenchmark3Y)
                                                    :maxLimit=parseFloat(this.maxSpreadBenchmark3Y)
                                                    :smalltitle="false"
                                                    :step="1"
                                                    :fixed="0"
                                                    :format="'percent'"
                                                    :arr="basic.minMaxBenchmark3y"
                                                    :nobuttons="true"
                                                    :clear="clearSpreadBenchmarkSlider">
                                                </quantile>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="columns is-justify-content-center">
                                        <div class="column is-9-tablet">

                                            <div class="filter-form-control mb-6">
                                                <quantile
                                                    v-on:slider-change="basic.minMaxBenchmark5y=$event"
                                                    :title="'5 Year'"
                                                    :suffix="'%'"
                                                    :minLimit=parseFloat(this.minSpreadBenchmark5Y)
                                                    :maxLimit=parseFloat(this.maxSpreadBenchmark5Y)
                                                    :smalltitle="false"
                                                    :step="1"
                                                    :fixed="0"
                                                    :format="'percent'"
                                                    :arr="basic.minMaxBenchmark5y"
                                                    :nobuttons="true"
                                                    :clear="clearSpreadBenchmarkSlider">
                                                </quantile>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            <template v-else>
                                <div class="columns is-justify-content-center is-size-6 red">Select benchmark using the yellow drop-down at the top of the results page</div>
                            </template>
                            <hr>

                            <h3 class="is-uppercase has-text-weight-bold mb-5"><img src="/img/calendar.png"> Fund History
                                <a class="clear-btn" @click="cl1">Clear</a>
                            </h3>


                            <div class="columns is-justify-content-center">
                                <div class="column is-9-tablet">
                                    <div class="filter-form-control mb-6">
                                        <quantile
                                            v-on:slider-change="basic.oldestsharedate=$event"
                                            :title="'Years since launch'"
                                            :suffix="'%'"
                                            :minLimit=parseFloat($store.state.search.maxMins.minoldestsharedate)
                                            :maxLimit=parseFloat($store.state.search.maxMins.maxoldestsharedate)
                                            :smalltitle="false"
                                            :arr="basic.oldestsharedate"
                                            :step="1"
                                            :fixed="0"
                                            :format="''"
                                            :nobuttons="true"
                                            :clear="clearSlider1"></quantile>
                                    </div>
                                </div>
                            </div>
                            <div class="columns is-justify-content-center">
                                <div class="column is-9-tablet">

                                    <div class="filter-form-control mb-6">
                                        <quantile
                                            v-on:slider-change="basic.oldmanagerdate=$event"
                                            :title="'Manager tenure years'"
                                            :suffix="'%'"
                                            :minLimit=parseFloat($store.state.search.maxMins.minoldestmanagerdate)
                                            :maxLimit=parseFloat($store.state.search.maxMins.maxoldestmanagerdate)
                                            :smalltitle="false"
                                            :step="1"
                                            :fixed="0"
                                            :format="''"
                                            :arr="basic.oldmanagerdate"
                                            :nobuttons="true"
                                            :clear="clearSlider1"></quantile>
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <h3 class="is-uppercase has-text-weight-bold mb-5"><img src="/img/Fund_Features.svg"> Fund Features
                                <a class="clear-btn" @click="basic.currencyhedged_all='A',basic.performancefee_oldest_share='A',basic.LeveragedFund='A',basic.benchmark='A',basic.physicalyreplicated='A',basic.discounttoNAV='A'">Clear</a>
                            </h3>
                            <div class="filter-form-control mb-4">
                                <div class="columns is-justify-content-center">
                                    <div class="column is-9-tablet">
                                        <label>Currency Hedged</label>
                                        <div class="field field-radio">
                                            <div>
                                                <b-radio v-model="basic.currencyhedged_all"
                                                        name="radio1"
                                                        size="is-small"
                                                        native-value="A">
                                                    All
                                                </b-radio>
                                            </div>
                                            <div>
                                                <b-radio v-model="basic.currencyhedged_all"
                                                        name="radio1"
                                                        size="is-small"
                                                        native-value="Y">
                                                    Yes
                                                </b-radio>
                                            </div>
                                            <div>
                                                <b-radio v-model="basic.currencyhedged_all"
                                                        name="radio1"
                                                        size="is-small"
                                                        native-value="N">
                                                    No
                                                </b-radio>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="filter-form-control mb-4">
                                <div class="columns is-justify-content-center">
                                    <div class="column is-9-tablet">
                                        <label>Charges Performance Fee</label>
                                        <div class="field field-radio">
                                            <div>
                                                <b-radio v-model="basic.performancefee_oldest_share"
                                                        name="radio2"
                                                        size="is-small"
                                                        native-value="A">
                                                    All
                                                </b-radio>
                                            </div>
                                            <div>
                                                <b-radio v-model="basic.performancefee_oldest_share"
                                                        name="radio2"
                                                        size="is-small"
                                                        native-value="Y">
                                                    Yes
                                                </b-radio>
                                            </div>
                                            <div>
                                                <b-radio v-model="basic.performancefee_oldest_share"
                                                        name="radio2"
                                                        size="is-small"
                                                        native-value="N">
                                                    No
                                                </b-radio>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <!-- <div class="filter-form-control mb-4">
                                <div class="columns is-justify-content-center">
                                    <div class="column is-9-tablet">
                                        <label>Can Use Leverage</label>
                                        <div class="field field-radio">
                                            <div>
                                                <b-radio v-model="basic.LeveragedFund"
                                                        name="radio3"
                                                        size="is-small"
                                                        native-value="A">
                                                    All
                                                </b-radio>
                                            </div>
                                            <div>
                                                <b-radio v-model="basic.LeveragedFund"
                                                        name="radio3"
                                                        size="is-small"
                                                        native-value="Y">
                                                    Yes
                                                </b-radio>
                                            </div>
                                            <div>
                                                <b-radio v-model="basic.LeveragedFund"
                                                        name="radio3"
                                                        size="is-small"
                                                        native-value="N">
                                                    No
                                                </b-radio>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> -->

                            <div class="filter-form-control mb-4">
                                <div class="columns is-justify-content-center">
                                    <div class="column is-9-tablet">
                                        <label>Has a Designated Benchmark</label>
                                        <div class="field field-radio">
                                            <div>
                                                <b-radio v-model="basic.benchmark"
                                                        name="radio4"
                                                        size="is-small"
                                                        native-value="A">
                                                    All
                                                </b-radio>
                                            </div>
                                            <div>
                                                <b-radio v-model="basic.benchmark"
                                                        name="radio4"
                                                        size="is-small"
                                                        native-value="Y">
                                                    Yes
                                                </b-radio>
                                            </div>
                                            <div>
                                                <b-radio v-model="basic.benchmark"
                                                        name="radio4"
                                                        size="is-small"
                                                        native-value="N">
                                                    No
                                                </b-radio>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="filter-form-control mb-4">
                                <div class="columns is-justify-content-center">
                                    <div class="column is-9-tablet">
                                        <label>Uses Physical Replication</label>
                                        <div class="field field-radio">
                                            <div>
                                                <b-radio v-model="basic.physicalyreplicated"
                                                        name="radio5"
                                                        size="is-small"
                                                        native-value="A">
                                                    All
                                                </b-radio>
                                            </div>
                                            <div>
                                                <b-radio v-model="basic.physicalyreplicated"
                                                        name="radio5"
                                                        size="is-small"
                                                        native-value="Y">
                                                    Yes
                                                </b-radio>
                                            </div>
                                            <div>
                                                <b-radio v-model="basic.physicalyreplicated"
                                                        name="radio5"
                                                        size="is-small"
                                                        native-value="N">
                                                    No
                                                </b-radio>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <h3 class="is-uppercase has-text-weight-bold mb-5"><img src="/img/Fund_Portfolio.svg"> Fund Portfolio
                                <!--<span>(4)</span>-->
                                <a class="clear-btn" @click="cl2">Clear</a>
                            </h3>
                            <div class="filter-form-control mb-6">
                                <div class="columns is-justify-content-center">
                                    <div class="column is-9-tablet">
                                        <quantile
                                            v-on:slider-change="basic.NumberOfHolding=$event"
                                            :title="'Number of holdings'"
                                            :suffix="''"
                                            :percentileType="'NumberOfHolding'"
                                            :arr="basic.NumberOfHolding"
                                            :minLimit=parseFloat($store.state.search.maxMins.minnumberofholding)
                                            :maxLimit=parseFloat($store.state.search.maxMins.maxnumberofholding)
                                            :smalltitle="false"
                                            :clear="clearSlider2"
                                            :nobuttons="true"
                                            :fixed="1"
                                            :format="''"
                                            :step=1
                                        ></quantile>
                                    </div>
                                </div>
                            </div>

                            <hr>
                            <h3 class="is-uppercase has-text-weight-bold mb-5"><img style="max-width: 35px; margin-bottom: .15em;" src="/img/Fund_Analytics.svg"> Fund Analytics
                                <!--<span>(4)</span>-->

                                <a class="clear-btn" @click="cl3">Clear</a>

                            </h3>

                            <div class="filter-form-control mb-6">
                                <div class="columns is-justify-content-center">
                                    <div class="column is-9-tablet">
                                        <quantile
                                            v-on:slider-change="basic.minMaxSharperatio3Y=$event"
                                            :title="'3Y Sharpe Ratio'"
                                            :suffix="''"
                                            :percentileType="'minMaxSharperatio3Y'"
                                            :arr="basic.minMaxSharperatio3Y"
                                            :minLimit=parseFloat($store.state.search.maxMins.minsharperatio3y)
                                            :maxLimit=parseFloat($store.state.search.maxMins.maxsharperatio3y)
                                            :smalltitle="false"
                                            :clear="clearSlider3"
                                            :step="0.01"
                                            :fixed="1"
                                            :format="''"
                                            :reverse="true"
                                        />

                                    </div>
                                </div>
                            </div>

                            <div class="filter-form-control mb-6">
                                <div class="columns is-justify-content-center">
                                    <div class="column is-9-tablet">
                                        <quantile
                                            v-on:slider-change="basic.standarddev36m=$event"
                                            :title="'3Y Standard Deviation'"
                                            :suffix="''"
                                            :percentileType="'standarddev36m'"
                                            :arr="basic.standarddev36m"
                                            :minLimit=parseFloat($store.state.search.maxMins.minstandarddev36m)
                                            :maxLimit=parseFloat($store.state.search.maxMins.maxstandarddev36m)
                                            :smalltitle="false"
                                            :clear="clearSlider3"
                                            :step="0.01"
                                            :fixed="1"
                                            :format="'percent'"
                                            :reverse="true"
                                        ></quantile>

                                    </div>
                                </div>
                            </div>

                            <div class="filter-form-control mb-4">
                                <div class="columns is-justify-content-center">
                                    <div class="column is-9-tablet">
                                        <label>Trading at Premium/Discount to Nav</label>
                                        <div class="field field-radio">
                                            <div>
                                                <b-radio v-model="basic.discounttoNAV"
                                                         name="radio6"
                                                         size="is-small"
                                                         native-value="A">
                                                    All
                                                </b-radio>
                                            </div>
                                            <div>
                                                <b-radio v-model="basic.discounttoNAV"
                                                         name="radio6"
                                                         size="is-small"
                                                         native-value="Y">
                                                    Premium
                                                </b-radio>
                                            </div>
                                            <div>
                                                <b-radio v-model="basic.discounttoNAV"
                                                         name="radio6"
                                                         size="is-small"
                                                         native-value="N">
                                                    Discount
                                                </b-radio>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="popup-floating">
                                <div class="container is-max-tablet is-max-desktop is-max-fullhd">
                                    <div class="columns">
                                        <div class="column is-9-desktop px-4">
                                            <p class="my-3 is-size-6 ml-2"><strong>{{ calTotal }} of {{this.$store.state.search.searchData.total_search}} Funds</strong></p>
                                            <div class="buttons ml-2">
                                                <button class="button is-secundary mr-3" @click="cleanAll">clear all</button>
                                                <button class="button is-primary mx-3" @click="submit(true)">Apply</button>
                                                <span class="is-hidden-mobile m-l-10-tablet">
                                                    <page-help :height="'560px'" :pageHelp="'filters'"/>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="column is-3-desktop m-t-100-desktop">
                        <div class="ad">
                            <h2>AD</h2>
                        </div>
                        <div class="ad mt-4">
                            <h2>AD</h2>
                        </div>
                    </div> -->
                </div>
            </div>
        </section>
        <footer class="modal-card-foot has-text-right p-t-0 p-r-0 p-b-0 p-l-0">
            <button @click="confirm()" class="button is-primary is-fullwidth">Close Filters</button>
        </footer>
    </div>
</template>

<script>
import Quantile from "@/components/Quantile";
import {cats, catslist} from "@/plugins/cats";
import PageHelp from '@/components/PageHelp.vue';

export default {
    name: 'Basicfilter',
    components: {
        quantile: Quantile,
        PageHelp
    },
    props: {
        clean:Boolean,
        /*absoluteTotal:Number,
        newtotal:Number,
        filterReturned:Object,
        preFilterTotal:Number*/
    },
    computed:{
        calTotal(){
            if("total" in this.$store.state.search.provisionalSearch){
                return this.$store.state.search.provisionalSearch.total
            }
            else{
                return this.$store.state.search.searchData.total_search
            }
        },
        minSpreadBenchmarkYTD() {
            if (!this.$store.state.search.compareBenchmarkFilter) return 0
            return this.$store.state.search.maxMins.mincumulativetotalreturntd - this.$store.state.search.latestSpreadBenchmarkData.spreadvsbenchmarkytd
        },
        maxSpreadBenchmarkYTD() {
            if (!this.$store.state.search.compareBenchmarkFilter) return 0
            return this.$store.state.search.maxMins.maxcumulativetotalreturntd - this.$store.state.search.latestSpreadBenchmarkData.spreadvsbenchmarkytd
        },
        minSpreadBenchmark1Y() {
            if (!this.$store.state.search.compareBenchmarkFilter) return 0
            return this.$store.state.search.maxMins.mincumulativetotalreturn1year - this.$store.state.search.latestSpreadBenchmarkData.spreadvsbenchmark1y
        },
        maxSpreadBenchmark1Y() {
            if (!this.$store.state.search.compareBenchmarkFilter) return 0
            return this.$store.state.search.maxMins.maxcumulativetotalreturn1year - this.$store.state.search.latestSpreadBenchmarkData.spreadvsbenchmark1y
        },
        minSpreadBenchmark3Y() {
            if (!this.$store.state.search.compareBenchmarkFilter) return 0
            return this.$store.state.search.maxMins.mintotalreturn3years - this.$store.state.search.latestSpreadBenchmarkData.spreadvsbenchmark3y
        },
        maxSpreadBenchmark3Y() {
            if (!this.$store.state.search.compareBenchmarkFilter) return 0
            return this.$store.state.search.maxMins.maxtotalreturn3years - this.$store.state.search.latestSpreadBenchmarkData.spreadvsbenchmark3y
        },
        minSpreadBenchmark5Y() {
            if (!this.$store.state.search.compareBenchmarkFilter) return 0
            return this.$store.state.search.maxMins.mintotalreturn5years - this.$store.state.search.latestSpreadBenchmarkData.spreadvsbenchmark5y
        },
        maxSpreadBenchmark5Y() {
            if (!this.$store.state.search.compareBenchmarkFilter) return 0
            return this.$store.state.search.maxMins.maxtotalreturn5years - this.$store.state.search.latestSpreadBenchmarkData.spreadvsbenchmark5y
        },
    },
    data() {
        return {
            cats: catslist(),
            clearSlider1: false,
            clearSlider2: false,
            clearSlider3: false,
            clearSpreadBenchmarkSlider: false,
            basic: {
                minMaxSharperatio3Y: [],
                currencyhedged_all: "A",
                performancefee_oldest_share:"A",
                LeveragedFund:"A",
                benchmark:"A",
                discounttoNAV:"A",
                physicalyreplicated:"A",
                standarddev36m:[],
                NumberOfHolding:[],
                oldmanagerdate:[],
                oldestsharedate:[],
                minMaxBenchmarkytd: [],
                minMaxBenchmark1y: [],
                minMaxBenchmark3y: [],
                minMaxBenchmark5y: [],
                isin_benchmark: this.$store.state.search.compareBenchmarkFilter
            },
            saveKeys: {},
        }
    },
    methods: {
        confirm() {
            this.$buefy.dialog.confirm({
                class: 'prueba',
                type: 'is-danger',
                hasIcon: true,
                message: 'Exit without saving changes?',
                onConfirm: () => this.closeMe()
            })
        },
        closeMe(){
            this.$store.commit("search/SET_PROV_FILTERS",this.$store.state.search.filters)
            //this.$store.commit("search/SET_PROV_FILTERS",)
            this.$emit('scrollPageToTopAfterFilter', true)
            this.$parent.close()
            this.$emit("working-filter", false)
        },
        catsArray() {
            return Object.keys(cats).map((key) => [key, cats[key]]);
        },
        catslist() {
            return catslist()
        },
        shortlist() {
            //return  shortlist()
        },

    cl1(){
        this.clearSlider1 = !this.clearSlider1;
        this.basic.oldestsharedate = []
        this.basic.oldmanagerdate = []
        this.$store.dispatch("search/apiCall", this.$store.state.search.lastSearch)
    },
    cl2(){
        this.clearSlider2 = !this.clearSlider2;
        this.basic.NumberOfHolding = []
        this.$store.dispatch("search/apiCall", this.$store.state.search.lastSearch)
    },
    cl3(){
        this.clearSlider3 = !this.clearSlider3;
        this.basic.standarddev36m = []
        this.basic.minMaxSharperatio3Y = []
        this.$store.dispatch("search/apiCall", this.$store.state.search.lastSearch)
    },
        clearSpreadBenchmark() {
            this.clearSpreadBenchmarkSlider = !this.clearSpreadBenchmarkSlider
            this.basic.minMaxBenchmarkytd = []
            this.basic.minMaxBenchmark1y = []
            this.basic.minMaxBenchmark3y = []
            this.basic.minMaxBenchmark5y = []
            this.$store.dispatch("search/apiCall", this.$store.state.search.lastSearch)
        },
        cleanAll() {
            this.clearSlider1 = !this.clearSlider1
            this.clearSlider2 = !this.clearSlider2
            this.clearSlider3 = !this.clearSlider3
            this.clearSpreadBenchmarkSlider = !this.clearSpreadBenchmarkSlider
            this.basic.currencyhedged_all = "A"
            this.basic.performancefee_oldest_share = "A"
            this.basic.LeveragedFund = "A"
            this.basic.benchmark = "A"
            this.basic.discounttoNAV = "A"
            this.basic.physicalyreplicated = "A"
            this.basic.standarddev36m = []
            this.basic.NumberOfHolding = []
            this.basic.oldestsharedate = []
            this.basic.oldmanagerdate = []
            this.basic.minMaxBenchmarkytd = []
            this.basic.minMaxBenchmark1y = []
            this.basic.minMaxBenchmark3y = []
            this.basic.minMaxBenchmark5y = []
            this.basic.minMaxSharperatio3Y = []
        },
        switchIt(){
            this.$emit("switch-it")
            this.submit(false)
        },
        async submit(apply) {
            let savekeys = this.saveKeys;
            Object.assign(savekeys, this.saveKeys)
            this.saveKeys = {};
            for (let key of Object.keys(savekeys)) {
                if(this.basic[key]) {
                    if(this.basic[key] !== 'A' && this.basic[key].length > 0 || this.basic[key] === true) {
                        this.saveKeys[key] = this.basic[key];
                    }
                }
            }

            const countAdvance = this.basic.isin_benchmark ? Object.keys(this.saveKeys).length - 1 : Object.keys(this.saveKeys).length

            this.$store.commit("search/SET_COUNT_ADVANCE", countAdvance )

            //this.$emit("search-filter", this.basic)
            this.$emit("working-filter", false);
            this.$store.commit("search/SET_FILTERS", {...this.basic, count_filters_advance: countAdvance })
            if (apply) {
                await this.$store.dispatch("search/apiCall", this.$store.state.search.lastSearch)
                this.$emit('scrollPageToTopAfterFilter', true)
                this.$parent.close()
            }
        }
    },
    watch:{
        basic:{
            deep: true,
            //immediate: true,
            handler(){
                let convertAssetManager = [];
                if(this.basic.assetManager) {
                    this.basic.assetManager.forEach(el => {
                        Object.keys(this.$store.state.search.smallShort).map(key => {
                        if(el === this.$store.state.search.smallShort[key]) {
                            convertAssetManager.push(key)
                        }
                    })
                    })
                }
                else {
                    convertAssetManager = this.basic.assetManager
                }
                this.$store.dispatch("search/provisionalCall", {...this.basic, assetManager: convertAssetManager})
                this.$emit("working-filter", true)
            }
        },
        clean:function (){
            this.cleanAll()
        },
    },
    async mounted() {
        Object.assign(this.saveKeys, this.basic)
        Object.assign(this.basic, this.$store.state.search.filters)

    }
}
</script>
